export default __webpack_public_path__ + "static/media/fb.c8db16e2.jpg";